import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"pencil\"><path d=\"M17.71 4.043c.39-.39.39-1.04 0-1.41L15.37.292c-.37-.39-1.02-.39-1.41 0l-1.84 1.83 3.75 3.75 1.84-1.83zM0 14.253v3.75h3.75l11.06-11.07-3.75-3.75L0 14.253z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol